import call from '~/assets/icons/call.svg';
import message from '~/assets/icons/message.svg';
import { Text } from '~/components/ui/Text';
import { CallHistoryStatus, formatTime } from '~/shared';
import { useContactName } from '../../hooks/useContactName';
import {
	StyledContainer,
	StyledIcon,
	StyledLeftContainer,
	StyledRightContainer,
} from './AppPhoneCallHistoryItem.styled';
const AppPhoneCallHistoryItem = ({
	contactNumber,
	timestamp,
	status,
	duration,
	onMessageClick,
	onCallClick,
}: {
	contactNumber: string;
	timestamp: number;
	status: CallHistoryStatus;
	duration?: number;
	onMessageClick: () => void;
	onCallClick: () => void;
}) => {
	const contactName = useContactName(contactNumber);
	const displayName = contactName || contactNumber;

	return (
		<StyledContainer>
			<StyledLeftContainer>
				<Text style={{ fontSize: 14, fontWeight: 500 }}>
					<span style={{ color: status === 'missed' ? '#C71E1E' : '#ffffff' }}>
						{displayName}
					</span>{' '}
					<span style={{ fontWeight: 400, opacity: 0.5 }}>
						{formatTime(timestamp, '{hh}:{mm}', { useMoscowTimezone: true })}
					</span>
				</Text>
				<Text style={{ fontSize: 12, fontWeight: 500, opacity: 0.5 }}>
					{status === 'missed'
						? 'Пропущенный'
						: `Звонок ${formatTime((duration ?? 0) * 1000, '{mm}:{ss}')}`}
				</Text>
			</StyledLeftContainer>
			<StyledRightContainer>
				<StyledIcon onClick={onCallClick}>
					<img src={call} alt="" />
				</StyledIcon>
				<StyledIcon onClick={onMessageClick}>
					<img src={message} alt="" />
				</StyledIcon>
			</StyledRightContainer>
		</StyledContainer>
	);
};

export { AppPhoneCallHistoryItem };
